import { twMerge } from 'tailwind-merge';
import type { UndecoratedScanService } from '@witmetrics/utils';
import { classes, parseTokenCount } from './utils';

export type TokenCountChipProps = {
  className?: string;
  labelClassName?: string;
  price?: UndecoratedScanService['price'];
};

export default function TokenCountChip({
  className,
  price,
}: TokenCountChipProps) {
  return (
    <span className={twMerge(classes.label, className)}>
      {`${parseTokenCount(price)} credits`}
    </span>
  );
}
